import { useMemo } from "react";
import DottedMap from "dotted-map";
import { motion } from "framer-motion";

export const WorldMap = ({ pins, className = "", dotColor = "#C6CCD8" }) => {
    const { dots, markers, width, height } = useMemo(() => {
        const map = new DottedMap({ height: 60, grid: "diagonal" });
        pins.forEach((p) =>
            map.addPin({ lat: p.lat, lng: p.lng, data: p.city })
        );
        const all = map.getPoints();
        return {
            dots: all.filter((p) => !p.data),
            markers: all.filter((p) => p.data),
            width: map.width,
            height: map.height,
        };
    }, [pins]);

    return (
        <svg
            viewBox={`0 0 ${width} ${height}`}
            className={className}
            role="img"
            aria-label="Illustrative world map showing the AV Consultation talent network"
            data-testid="world-map"
        >
            {dots.map((d, i) => (
                <circle key={i} cx={d.x} cy={d.y} r={0.3} fill={dotColor} />
            ))}
            {markers.map((m, i) => (
                <g key={m.data} data-testid={`map-pin-${i}`}>
                    <motion.circle
                        cx={m.x}
                        cy={m.y}
                        fill="#2D5BFF"
                        initial={{ r: 0.6, opacity: 0.5 }}
                        animate={{ r: [0.6, 2], opacity: [0.45, 0] }}
                        transition={{
                            duration: 2.6,
                            repeat: Infinity,
                            delay: (i % 8) * 0.3,
                            ease: "easeOut",
                        }}
                    />
                    <circle cx={m.x} cy={m.y} r={0.6} fill="#2D5BFF" />
                    <circle cx={m.x} cy={m.y} r={0.25} fill="#fff" />
                </g>
            ))}
        </svg>
    );
};

export default WorldMap;
